import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from 'actions/userInfo.actions';
import React, { useEffect } from 'react';
import { getSessionRole, USER_ROLE } from 'helpers/session';
import { isInvisibleUser } from 'helpers/userHelper';

export const withUserInfo = Cmp => {
  const WithUserInfoHoC = props => {
    const userInfoMeta = useSelector(state => state.userInfo);
    const { loggedIn, ocfLoggedIn } = useSelector(state => ({
      loggedIn: state.app.loggedIn,
      ocfLoggedIn: state.app.ocfLoggedIn,
    }));
    const { userInfo, userInfoLoading, userInfoError } = userInfoMeta;
    const isUserSessionActive = getSessionRole() === USER_ROLE;
    const requestWillStart =
      !userInfoLoading &&
      !userInfoError &&
      !userInfo &&
      isUserSessionActive &&
      loggedIn;
    const dispatch = useDispatch();
    const isOcfRole = ocfLoggedIn === true;

    useEffect(() => {
      if (requestWillStart && !isOcfRole) {
        dispatch(getUserInfo()).then(user => {});
      }
    });

    return (
      <Cmp
        {...props}
        userInfo={userInfo}
        isInvisibleUser={isInvisibleUser(userInfo)}
        userInfoLoading={userInfoLoading || requestWillStart}
        userInfoError={userInfoError}
      />
    );
  };

  return WithUserInfoHoC;
};
